const Fork = (props) => (
  <svg
    fill="#ffffff"
    width="30px"
    height="30px"
    viewBox="0 0 163.476 163.476"
    xmlSpace="preserve"
    stroke="#ffffff"
    {...props}
  >
    <g>
      <path d="M88.291,9.223v41.432c0,13.239-9.229,24.009-20.58,24.009h-1.273v76.341c0,6.886-5.582,12.471-12.467,12.471 c-6.887,0-12.469-5.581-12.469-12.471V74.664h-1.277c-11.347,0-20.576-10.77-20.576-24.009V9.223c0-4.588,3.716-8.309,8.304-8.309 c4.592,0,8.311,3.721,8.311,8.309v41.432c0,4.443,2.382,7.39,3.961,7.39h5.431V9.229c0-4.588,3.721-8.309,8.308-8.309 c4.583,0,8.305,3.721,8.305,8.309v48.816h5.43c1.573,0,3.961-2.947,3.961-7.39V9.223c0-4.588,3.721-8.309,8.311-8.309 C84.56,0.914,88.291,4.635,88.291,9.223z M143.517,16.906C142.662,7.447,134.805,0,125.117,0c-10.255,0-18.561,8.309-18.561,18.564 l0,0c-0.044,0.43-0.126,0.851-0.126,1.294v131.126c0,6.889,5.575,12.472,12.465,12.472c6.889,0,12.471-5.583,12.471-12.472V109.43 c6.884,0,12.46-5.576,12.46-12.455V19.549C143.81,18.648,143.7,17.763,143.517,16.906z"/>
    </g>
  </svg>
);

export default Fork;
